<template>
    <div>
        <div v-for="(category, index) in allCategories" v-if="showCategory(category)">
            <a :ref="`category-${category.id}`"
                         :style="categoryHeaderStyle(category, allCategories.length - index)"
                         :href="getCategoryLink(category)"
                         class="news-heading"
                         >
                <div class="wrapper">
                    <div class="news-heading__in">
                        <div class="news-heading__title">
                            <h1>{{getCategoryTitle(category)}}</h1>
                        </div>
                        <div class="news-heading__descr">
                            <p v-if="getCategoryDescription(category).length < 20">
                                {{getCategoryDescription(category)}}</p>
                            <p v-else>{{getCategoryDescription(category).substring(0,20)+".."}}</p>
                        </div>
                    </div>
                </div>
            </a>

            <div :ref="`category-articles-${category.id}`" class="news-container news-container--rounded">
                <div class="wrapper">
                    <div class="news-list news-list--col4">
                        <div class="news-card__col" v-for="n in getCategoryArticle(category)">
                            <a :href="getNewsLink(n, category)" class="news-card__item" >
                                <div class="news-card__image">
                                    <img :alt="n.title" :src="getArticleImage(n)"/>
                                </div>
                                <div class="news-card__text">
                                    <h4>{{getNewsTitle(n)}}</h4>
                                    <p v-if="getNewsDescription(n).length < 20">{{getNewsDescription(n)}}</p>
                                    <p v-else>{{getNewsDescription(n).substring(0,20)+".."}}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        props:['lang','cat_slug'],
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        computed: {
            ...mapGetters(['allSupports', 'allCategories', 'storage']),
            supports() {
                if (!!this.allSupports) {
                    let language = this.lang;
                    return this.allSupports[language];
                }
                return [];
            },
            otherSupports() {
                if (!!this.allSupports && this.allSupports.hasOwnProperty('en')) {
                    let language = this.lang;
                    return this.allSupports[language].slice(1);
                }
                return [];
            },
        },
        methods: {
            handleScroll(event) {
                let filteredRefs = Object.keys(this.$refs).filter(key => {
                    return key.indexOf('category-articles') !== -1;
                });
                let positions = [];
                for (let ref of filteredRefs) {
                    positions.push({
                        id: parseInt(ref.match(/\d+/)),
                        top: this.$refs[ref][0].getBoundingClientRect().top,
                        bottom: this.$refs[ref][0].getBoundingClientRect().bottom,
                        height: this.$refs[ref][0].getBoundingClientRect().height,
                    })
                }
                let windowScroll = window.scrollY;

                let visibleHeader = positions.filter(ref => {
                    return ref.top < (windowScroll+ref.height) && ref.top>0;
                    // return ref.top < (windowScroll + ref.height) && ref.bottom > (windowScroll - 200);
                });

                if (visibleHeader.length > 0) {
                    let ref = this.$refs['category-' + visibleHeader[0].id][0];
                    ref.style.zIndex = 200
                    $(ref.$el).css('z-index', 200);

                    let filteredRefs = Object.keys(this.$refs).filter(key => {
                        return key !== `category-${visibleHeader[0].id}`&& key.match(/category\-\d+/) !== null;
                    });
                    for (let ref of filteredRefs) {
                        this.$refs[ref][0].style.zIndex = 100
                        $(this.$refs[ref][0].$el).css('z-index', 100);
                    }
                }

            },
            getStorageLink(path) {
                return this.storage + path;
            },
            getArticleImage(article) {
                if (!!article.images && article.images.length > 0) {
                    return this.getStorageLink(article.images[0].image);
                }
                return null;
            },
            getCategoryArticle(category) {
                let language = this.lang;
                if (category[`${language}_supports`].length>0) {
                    return category[`${language}_supports`];
                }
                return category.supports;
            },
            showCategory(category) {
                return category.hasOwnProperty('supports') && category.supports.length > 0;
            },
            getCategoryDescription(category) {
                let language = this.lang;
                if (!!category[`${language}_desc`]) {
                    return category[`${language}_desc`];
                }
                return category.desc;
            },
            getCategoryTitle(category) {
                let language = this.lang;
                if (!!category[`${language}_title`]) {
                    return category[`${language}_title`];
                }
                return category.title;
            },
            categoryHeaderStyle(category, index) {
                if (!!category.img) {
                    return {
                        backgroundImage: 'url(' + this.getStorageLink(category.img) + ')',
                        zIndex: index + 100
                    }
                }
                return null;
            },
            getCategoryLink(category) {
                for (let cat of category.children){
                    if (!!cat.supports){
                        return `/${this.lang}/supports/${category.slug}`;
                    }
                }
                return false
            },
            ...mapActions(['getRootSupportCategories']),
            getNewsTitle(news) {
                let prefix;
                let language = this.lang;
                prefix = language + '_';
                if (language === 'en') {
                    prefix = '';
                }
                if (!!news && !!news[`${prefix}title`]) {
                    return news[`${prefix}title`]
                }
                return news[`title`]
            },
            getNewsDescription(news) {
                let prefix;
                let language = this.lang;
                prefix = language + '_';
                if (language === 'en') {
                    prefix = '';
                }
                if (!!news && !!news[`${prefix}desc`]) {
                    return news[`${prefix}desc`]
                }
                return news[`desc`]
            },
            getNewsLink(post, category) {
                if (post.slug) {
                    return `/${this.lang}/support/${category.slug}/${post.slug}`
                } else {
                    return '';
                }
            },
        },
        mounted() {
            this.getRootSupportCategories({
                path: this.$path,
                catSlug: this.cat_slug || null
            })
        },
        watch: {
            cat_slug: {
                handler: function (slug) {
                    if (!!slug) {
                        this.getRootSupportCategories({
                            path: this.$path,
                            catSlug: this.cat_slug || null
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .news-container {
        z-index: 1000;
        min-height: 100vh;
    }
</style>
